import {
  BASE_URL
} from 'aster-foundation/core/common/utils/ApiConst';
import Head from 'next/head';
import Link from 'next/link';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { BreadcrumbStyled } from './BreadcrumbStyled';
import {PRODUCTS_DETAILS_PAGE} from '@common/Utility/constants';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';
import { getLangCodeFromUrl } from '../../../../../i18n';
import { isRTL } from '@common/i18n';

const BreadcrumbControl = (props) => {
  const generateURL = useNavigationURL();
  const [currentLang, setCurrentLanguage] = useState('');

  useEffect(() => {
    if(window !== 'undefined'){
      setCurrentLanguage(getLangCodeFromUrl());
    }
  }, []);
  
  const breadcrumbCreation = () => {
    const breadcrumbArr = [];
    const reqUrl = typeof window !== 'undefined' ? window?.location?.origin?.replace(/\/$/, '') : 'https://www.myaster.com';
    props?.childs?.map((item, i) => {
      const breadcrumbChild = {
        '@type': 'ListItem',
        position: i + 1,
        name: item?.text,
        item: reqUrl + item?.link,
      };
      breadcrumbArr?.push(breadcrumbChild);
    });
    const breadcrumbMain = {
      '@type': 'ListItem',
      position: breadcrumbArr?.length + 1,
      name: props?.main,
    };
    breadcrumbArr?.push(breadcrumbMain);

    return breadcrumbArr;
  };
  const breadcrumbList = breadcrumbCreation();

  const breadCrumbSchemaData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbList,
  };
  const handleLinkClickSecond = (itemSecond) => {
    if (props?.onLinkClick) {
      props.onLinkClick(itemSecond);
    }
  };
  return (
    <BreadcrumbStyled className={`${props?.appVariant} ${currentLang && isRTL(currentLang) ? 'rtl' : ''}`}>
      <Head>
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadCrumbSchemaData) }} />
      </Head>
      <Breadcrumb>
        {props?.childs?.map((item, index) => {
          if (item?.link) {
            return (
                <Link
                  key={index}
                  passHref={true}
                  href={
                    item?.query
                      ? {
                          pathname: item?.link,
                          query: item?.query,
                        }
                      : {
                          pathname: item?.link,
                        }
                  }
                >
                  <Breadcrumb.Item
                    data-test="item"
                    onClick={() => {
                      if (props?.onLinkClick) {
                        props?.onLinkClick(item);
                      }
                    }}
                  >
                    {item?.text}
                  </Breadcrumb.Item>
                </Link>
            );
          } else if (item?.url) {
            return item.url.map((itemSecond) => (
              <Link
                key={itemSecond.id}
                passHref={true}
                href={
                  itemSecond?.query
                    ? {
                        pathname: itemSecond?.link,
                        query: itemSecond?.query,
                      } 
                    : {
                        pathname: generateURL(`/online-pharmacy/${itemSecond?.url}`),
                      }
                }
              >
                <Breadcrumb.Item
                  data-test="item"
                  onClick={() => handleLinkClickSecond(itemSecond)}
                >
                  {itemSecond?.name}
                </Breadcrumb.Item>
              </Link>
            ));
          } else {
            return (
              <Breadcrumb.Item
                key={index}
                data-test="item1"
                onClick={() => {
                  if (props?.onLinkClick) {
                    props?.onLinkClick(item);
                  }
                }}
              >
                {item?.text}
              </Breadcrumb.Item>
            );
          }
        })}
        <Breadcrumb.Item active>
          {props?.pageType && props?.pageType === PRODUCTS_DETAILS_PAGE ? (
            <span className="breadcrumb-text">
              {props?.main}
            </span>
          ) : (
            props?.main
          )}
        </Breadcrumb.Item>
      </Breadcrumb>
    </BreadcrumbStyled>
  );
};
BreadcrumbControl.propTypes = {
  url: PropTypes.any,
  text: PropTypes.string,
  main: PropTypes.any,
  linkText: PropTypes.string,
  href: PropTypes.any,
  handleLinkClick: PropTypes.any,
  innerText: PropTypes.string,
  childs: PropTypes.any,
  link: PropTypes.any,
  onLinkClick: PropTypes.any,
  pageType : PropTypes.string,
  appVariant: PropTypes.string,
};

BreadcrumbControl.defaultProps = {
  url: '',
  text: '',
  link: '',
  href: '',
  pageType: '',
  onLinkClick: null,
};

export default BreadcrumbControl;
